import { render, staticRenderFns } from "./waterfall.vue?vue&type=template&id=32ef4631&scoped=true&"
import script from "./waterfall.vue?vue&type=script&lang=js&"
export * from "./waterfall.vue?vue&type=script&lang=js&"
import style0 from "./waterfall.vue?vue&type=style&index=0&id=32ef4631&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ef4631",
  null
  
)

export default component.exports